import { THandleGetPromptsChatbot } from '../types';
import { DEFAULT_PROMPTS_AREA } from 'src/modules/store/constants/default';
import { TStorePrompts } from 'src/interfaces/store';

export const extractPromptsChatbot = ({
    area,
    prompts,
}: THandleGetPromptsChatbot) => {
    if (!area) return { success: false, name: area, ...DEFAULT_PROMPTS_AREA };
    let findPrompt = prompts.find((item: TStorePrompts) => item.name === area);
    if (findPrompt && findPrompt.name)
        return {
            success: true,
            ...findPrompt,
        };
    return {
        success: false,
        name: area,
        ...DEFAULT_PROMPTS_AREA,
    };
};
